import moment from "moment";

/* eslint-disable
    consistent-return,
    func-names,
    no-cond-assign,
    no-multi-assign,
    no-param-reassign,
    no-return-assign,
    no-shadow,
    no-undef,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let TimeFormatter;

export default TimeFormatter = (function () {
  TimeFormatter = class TimeFormatter {
    static initClass() {
      // At this time, all locales are expected to apply the 'house style'
      // for time formats which is (for now, until the backlash arrives)
      // an American style of date and time.
      this.prototype.formats = {
        tc_date: "MMMM D, YYYY", // September 29, 2014
        tc_short_month_date: "MMM D, YYYY", // Sep 29, 2014
        tc_date_with_time: "MMMM D, YYYY h.mma", // September 29, 2014 9.45am
        tc_time: "h.mma", // 9.45am
      };

      this.prototype.locales = {
        "fr-FR": {
          months: [
            "janvier",
            "février",
            "mars",
            "avril",
            "mai",
            "juin",
            "juillet",
            "août",
            "septembre",
            "octobre",
            "novembre",
            "décembre",
          ],
          monthsShort: [
            "janv.",
            "févr.",
            "mars",
            "avr.",
            "mai",
            "juin",
            "juil.",
            "août",
            "sept.",
            "oct.",
            "nov.",
            "déc.",
          ],
          weekdays: [
            "dimanche",
            "lundi",
            "mardi",
            "mercredi",
            "jeudi",
            "vendredi",
            "samedi",
          ],
          weekdaysShort: [
            "dim.",
            "lun.",
            "mar.",
            "mer.",
            "jeu.",
            "ven.",
            "sam.",
          ],
          weekdaysMin: [
            "Di",
            "Lu",
            "Ma",
            "Me",
            "Je",
            "Ve",
            "Sa",
          ],
          longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY LT",
            LLLL: "dddd D MMMM YYYY LT",
          },
          calendar: {
            sameDay: "[Aujourd'hui à] LT",
            nextDay: "[Demain à] LT",
            nextWeek: "dddd [à] LT",
            lastDay: "[Hier à] LT",
            lastWeek: "dddd [dernier à] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "dans %s",
            past: "il y a %s",
            s: "quelques secondes",
            m: "une minute",
            mm: "%d minutes",
            h: "une heure",
            hh: "%d heures",
            d: "un jour",
            dd: "%d jours",
            M: "un mois",
            MM: "%d mois",
            y: "une année",
            yy: "%d années",
          },
          ordinalParse: /\d{1,2}(er|ème)/,
          ordinal(number) {
            let left;
            return number + ((left = number === 1) != null ? left : { er: "ème" });
          },
          meridiemParse: /PD|MD/,
          isPM(input) {
            return input.charAt(0) === "M";
          },
          rangeSelectorFrom: "Du",
          rangeSelectorTo: "au",
        },
        "id-ID": {
          months: [
            "Januari",
            "Februari",
            "Maret",
            "April",
            "Mei",
            "Juni",
            "Juli",
            "Agustus",
            "September",
            "Oktober",
            "November",
            "Desember",
          ],
          monthsShort: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Mei",
            "Jun",
            "Jul",
            "Ags",
            "Sep",
            "Okt",
            "Nov",
            "Des",
          ],
          weekdays: [
            "Minggu",
            "Senin",
            "Selasa",
            "Rabu",
            "Kamis",
            "Jumat",
            "Sabtu",
          ],
          weekdaysShort: [
            "Min",
            "Sen",
            "Sel",
            "Rab",
            "Kam",
            "Jum",
            "Sab",
          ],
          weekdaysMin: [
            "Mg",
            "Sn",
            "Sl",
            "Rb",
            "Km",
            "Jm",
            "Sb",
          ],
          longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [pukul] HH.mm",
            LLLL: "dddd, D MMMM YYYY [pukul] HH.mm",
          },
          meridiemParse: /pagi|siang|sore|malam/,
          meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }
            if (meridiem === " pagi") {
              return hour;
            } else if (meridiem === " siang") {
              if (hour >= 11) { return hour; } return hour + 12;
            } else if ((meridiem === " sore") || (meridiem === " malam")) {
              return hour + 12;
            }
          },
          meridiem(hours, minutes, isLower) {
            if (hours < 11) {
              return " pagi";
            } else if (hours < 15) {
              return " siang";
            } else if (hours < 19) {
              return " sore";
            }
            return " malam";
          },
          calendar: {
            sameDay: "[Hari ini pukul] LT",
            nextDay: "[Besok pukul] LT",
            nextWeek: "dddd [pukul] LT",
            lastDay: "[Kemarin pukul] LT",
            lastWeek: "dddd [lalu pukul] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "dalam %s",
            past: "%s yang lalu",
            s: "beberapa detik",
            m: "semenit",
            mm: "%d menit",
            h: "sejam",
            hh: "%d jam",
            d: "sehari",
            dd: "%d hari",
            M: "sebulan",
            MM: "%d bulan",
            y: "setahun",
            yy: "%d tahun",
          },
          rangeSelectorFrom: "Dari",
          rangeSelectorTo: "untuk",
        },
        "es-ES": {
          months: [
            "enero",
            "febrero",
            "marzo",
            "abril",
            "mayo",
            "junio",
            "julio",
            "agosto",
            "septiembre",
            "octubre",
            "noviembre",
            "diciembre",
          ],
          monthsShort: [
            "ene",
            "feb",
            "mar",
            "abr",
            "may",
            "jun",
            "jul",
            "ago",
            "sep",
            "oct",
            "nov",
            "dic",
          ],
          weekdays: [
            "domingo",
            "lunes",
            "martes",
            "miércoles",
            "jueves",
            "viernes",
            "sábado",
          ],
          weekdaysShort: [
            "dom",
            "lun",
            "mar",
            "mié",
            "jue",
            "vie",
            "sáb.",
          ],
          weekdaysMin: [
            "do",
            "lu",
            "ma",
            "mi",
            "ju",
            "vi",
            "sá",
          ],
          calendar: {
            sameDay: "[hoy a la] LT",
            nextDay: "[mañana a la] LT",
            nextWeek: "dddd [a la] LT",
            lastDay: "[ayer a la] LT",
            lastWeek: "[el] dddd [pasado a la] LT",
            sameElse: "L",
          },
          relativeTime: {
            future: "en %s",
            past: "hace %s",
            s: "unos segundos",
            ss: "%d segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "una hora",
            hh: "%d horas",
            d: "un día",
            dd: "%d días",
            M: "un mes",
            MM: "%d meses",
            y: "un año",
            yy: "%d años",
          },
          dayOfMonthOrdinalParse: /\d{1,2}º/,
          ordinal: "%dº",
          meridiemParse: /AM|PM/,
          meridiem(hours, _minutes, _isLower) {
            return hours < 12 ? " AM" : " PM";
          },
          week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
          },
        },
      };
    }

    /**
     * Formats the given date/time
     * @param {string, Moment} time
     * @param {string} format. Example: "tc_date_with_time"
     * @return {string}
     */
    static formatted(time, format = "tc_date_with_time") {
      // TODO: we're relying on global TC.locale variable for now
      const currentLocale = (window.TC && window.TC.locale) || "en-AU";

      if (format == null) { format = "tc_date_with_time"; }

      moment.locale(currentLocale, this.prototype.locales[currentLocale]);
      return moment(time).format(this.prototype.formats[format]);
    }
  };
  TimeFormatter.initClass();
  return TimeFormatter;
}());
